<svg viewBox="0 0 800 500" class="animation-svg">
  <defs>
    <radialGradient id="grad1" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
      <stop offset="0%" style="stop-color:#fff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:var(--partials-breathing-animation-inner-circle-color);stop-opacity:1" />
    </radialGradient>
  </defs>

  <rect class="background-rect" width="800" height="500" />
  <circle cx="400" cy="250" r="200" class="breathing-circle" stroke-width="5" fill="none" />
  <circle cx="400" cy="450" r="10" class="breathing-marks" stroke-width="3" fill="none" />
  <circle cx="400" cy="50" r="10" class="breathing-marks" stroke-width="3" fill="none" />
  <circle cx="400" cy="450" r="30" class="breathing-circle-running" stroke-width="3" fill="none">
    <animateTransform id="inhale" attributeName="transform" type="rotate" values="0 400 250; 180 400 250" dur="4s" begin="0s;exhale.end+1s"/>
    <animateTransform id="exhale" attributeName="transform" type="rotate" values="180 400 250; 360 400 250" dur="5s" begin="inhale.end"/>
  </circle>

  <circle cx="0" cy="0" r="100" fill="url(#grad1)" transform="translate(400 250)">
    <animateTransform attributeName="transform" type="scale" additive="sum" values="1 1; 1.5 1.5" dur="4s" begin="inhale.begin" />
    <animateTransform attributeName="transform" type="scale" additive="sum" values="1.5 1.5; 1 1" dur="5s" begin="exhale.begin" />
  </circle>

    <text id="inhale_text" x="400" y="250" class="texts" opacity="0">
        {{breatheInText}}
        <animate attributeName="opacity" dur="4s" keyTimes="0;0.05;0.9;1" values="0;1;1;0" begin="inhale.begin"/>
    </text>
    <text id="exhale_text" x="400" y="250" class="texts" opacity="0">
        {{breatheOutText}}
        <animate attributeName="opacity" dur="5s" keyTimes="0;0.05;0.9;1" values="0;1;1;0" begin="exhale.begin"/>
    </text>
</svg>
